import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import { MatFormField } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'am-file-input',
  templateUrl: './file-input.component.html',
  styleUrl: './file-input.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => FileInputComponent),
    },
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatFormField, MatInput, ReactiveFormsModule, AsyncPipe],
  standalone: true,
})
export class FileInputComponent implements ControlValueAccessor {
  @Input() label?: string;

  @Input() placeholder: string;

  @Input() acceptFileType?: string[];

  currentFile?: File;

  fileCtrl = new FormControl('');

  displayedPlaceholder$ = new BehaviorSubject<string>('');

  onChanged: any = () => {
    /* */
  };
  onTouched: any = () => {
    /* */
  };

  registerOnChange(fn: any): void {
    this.onChanged = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  writeValue(inputValue: any): void {
    if (inputValue == null) {
      this.fileCtrl.setValue(inputValue);
      this._setPlaceholder();
    }
  }

  handleFileInputChange(event: any): void {
    if (event?.target.files?.[0]) {
      const [file] = event.target.files;
      this.currentFile = file;
      this.onChanged(file);
    } else {
      this.currentFile = undefined;
      this.fileCtrl.setValue(null);
    }

    this._setPlaceholder(this.currentFile);
  }

  private _setPlaceholder(currentFile?: File): void {
    if (currentFile != null) {
      this.displayedPlaceholder$.next(currentFile.name);
    } else {
      this.displayedPlaceholder$.next(this.placeholder);
    }
  }
}
